import { Grid } from '@mui/material';
import { parseSecondsToString } from '@nx-smartmonkey/shared/helpers';
import { HSpacer, RoutalPalette } from '@nx-smartmonkey/ui';
import { useIntl } from 'react-intl';

import { DistanceType } from '../../../domain/driversProject/DriversProject';
import { Route } from '../../../domain/route/Route';
import { Text } from '../../../react-components/Text';
import { ItemsSeparator } from '../components/ItemsSeparator';

interface RoutePillInfoProps {
  route: Route;
  distanceType: DistanceType;
  color?: string;
}

export const RoutePillInfo = ({ route, distanceType, color }: RoutePillInfoProps) => {
  const intl = useIntl();
  const stopsTranslation = intl.formatMessage({ id: `driver.routes.route_info.stops` });

  const routeInfo = [
    `${route.stops.length} ${stopsTranslation}`,
    route.planned_end_time !== undefined && route.planned_start_time !== undefined
      ? `${parseSecondsToString(
          route.planned_end_time && route.planned_start_time
            ? route.planned_end_time - route.planned_start_time
            : undefined
        )}`
      : `00h 00m`,
    `${route.getTotalDistance(distanceType).toString()} ${distanceType}`,
  ];
  return (
    <Grid
      container
      style={{
        fontSize: `12px`,
        color: RoutalPalette.grey1,
      }}
    >
      {routeInfo.map((routeDataItem, index) => {
        return (
          <Grid
            item
            key={`route-info-${index}`}
            style={{
              display: `flex`,
              alignItems: `center`,
              padding: 0,
              justifyContent: `center`,
            }}
          >
            <Text style={{ color: color }}>{routeDataItem}</Text>
            {index < routeInfo.length - 1 && (
              <>
                <HSpacer small />
                <ItemsSeparator />
                <HSpacer small />
              </>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};
